import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_7 = { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_8 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_9 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_10 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_11 = {
  key: 1,
  class: "text-center py-5 text-danger-500"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_13 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_14 = {
  key: 3,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_15 = { class: "w-full without-border" }
const _hoisted_16 = { class: "text-black dark:text-white" }
const _hoisted_17 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_22 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_23 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_24 = { class: "text-black dark:text-white" }
const _hoisted_25 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_26 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_27 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "block font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_31 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_32 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_33 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_34 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_35 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_36 = { class: "flex items-center gap-[9px]" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
}
const _hoisted_41 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md w-full max-w-md" }
const _hoisted_42 = { class: "text-lg font-semibold mb-4" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "block text-sm font-medium mb-1" }
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = { class: "block text-sm font-medium mb-1" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "block text-sm font-medium mb-1" }
const _hoisted_49 = { value: "" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = { class: "block text-sm font-medium mb-1" }
const _hoisted_53 = { value: "high" }
const _hoisted_54 = { value: "medium" }
const _hoisted_55 = { value: "low" }
const _hoisted_56 = { class: "mb-3" }
const _hoisted_57 = { class: "block text-sm font-medium mb-1" }
const _hoisted_58 = { value: "pending" }
const _hoisted_59 = { value: "in_progress" }
const _hoisted_60 = { value: "completed" }
const _hoisted_61 = { value: "cancelled" }
const _hoisted_62 = { class: "mb-4" }
const _hoisted_63 = { class: "block text-sm font-medium mb-1" }
const _hoisted_64 = { class: "flex justify-end space-x-2" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
}
const _hoisted_69 = { class: "bg-white dark:bg-[#0c1427] p-5 rounded-md w-full max-w-md" }
const _hoisted_70 = { class: "text-lg font-semibold mb-4" }
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = { class: "block text-sm font-medium" }
const _hoisted_73 = { class: "mb-3" }
const _hoisted_74 = { class: "block text-sm font-medium" }
const _hoisted_75 = { class: "mb-3" }
const _hoisted_76 = { class: "block text-sm font-medium" }
const _hoisted_77 = { class: "mb-3" }
const _hoisted_78 = { class: "block text-sm font-medium" }
const _hoisted_79 = { class: "mb-3" }
const _hoisted_80 = { class: "block text-sm font-medium" }
const _hoisted_81 = { class: "mb-3" }
const _hoisted_82 = { class: "block text-sm font-medium" }
const _hoisted_83 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_84 = { class: "block text-sm font-medium" }
const _hoisted_85 = { class: "mt-1" }
const _hoisted_86 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.directT('todoList.searchTask'),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTaskModal(null)))
        }, [
          _createElementVNode("span", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add ", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.addNewTask')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "inline-block animate-spin rounded-full border-4 border-primary-500 border-t-transparent h-12 w-12 mb-4" }, null, -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.directT('todoList.loading')), 1)
          ]))
        : (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errorMessage), 1))
          : (_ctx.filteredTasks.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('todoList.noTasksFound')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", _hoisted_16, [
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, [
                        _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "cursor-pointer"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('todoList.id')), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('todoList.taskTitle')), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('todoList.assignedTo')), 1),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('todoList.dueDate')), 1),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('todoList.priority')), 1),
                      _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.directT('todoList.status')), 1),
                      _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.directT('todoList.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTasks, (task) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: task.id
                      }, [
                        _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                          _createElementVNode("div", { class: "form-check relative top-[2px]" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "cursor-pointer"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(task.id?.slice(0, 8)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(task.tasktitle), 1)
                        ]),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(task.assignedName || _ctx.directT('todoList.notAssigned')), 1),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatDate(task.duedate)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getLocalizedPriority(task.priority || 'medium')), 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getStatusClass(task.status))
                          }, _toDisplayString(_ctx.getLocalizedStatus(task.status)), 3)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "text-primary-500 leading-none custom-tooltip",
                              onClick: ($event: any) => (_ctx.viewTask(task))
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                            ]), 8, _hoisted_37)), [
                              [_directive_tooltip, _ctx.directT('todoList.view')]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                              onClick: ($event: any) => (_ctx.openTaskModal(task))
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                            ]), 8, _hoisted_38)), [
                              [_directive_tooltip, _ctx.directT('todoList.edit')]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              class: "text-danger-500 leading-none custom-tooltip",
                              onClick: ($event: any) => (_ctx.deleteTask(task))
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                            ]), 8, _hoisted_39)), [
                              [_directive_tooltip, _ctx.directT('todoList.delete')]
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
    ]),
    (_ctx.showTaskModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.editingTask ? _ctx.directT('todoList.editTask') : _ctx.directT('todoList.addTask')), 1),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.directT('todoList.taskTitle')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taskForm.tasktitle) = $event)),
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, null, 512), [
                [_vModelText, _ctx.taskForm.tasktitle]
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.directT('todoList.dueDate')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.taskForm.duedate) = $event)),
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, null, 512), [
                [_vModelText, _ctx.taskForm.duedate]
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.directT('todoList.assignedTo')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.taskForm.assignedto) = $event)),
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, [
                _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.directT('todoList.notAssigned')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: user.id,
                    value: user.id
                  }, _toDisplayString(user.email), 9, _hoisted_50))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.taskForm.assignedto]
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.directT('todoList.priority')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.taskForm.priority) = $event)),
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, [
                _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.directT('todoList.high')), 1),
                _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.directT('todoList.medium')), 1),
                _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.directT('todoList.low')), 1)
              ], 512), [
                [_vModelSelect, _ctx.taskForm.priority]
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.directT('todoList.status')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.taskForm.status) = $event)),
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, [
                _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.directT('todoList.pending')), 1),
                _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.directT('todoList.inProgress')), 1),
                _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.directT('todoList.completed')), 1),
                _createElementVNode("option", _hoisted_61, _toDisplayString(_ctx.directT('todoList.cancelled')), 1)
              ], 512), [
                [_vModelSelect, _ctx.taskForm.status]
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.directT('todoList.description')), 1),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.taskForm.description) = $event)),
                rows: "3",
                class: "w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
              }, null, 512), [
                [_vModelText, _ctx.taskForm.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeTaskModal && _ctx.closeTaskModal(...args))),
                class: "px-4 py-2 bg-gray-200 dark:bg-[#172036] rounded"
              }, _toDisplayString(_ctx.directT('todoList.cancel')), 1),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveTask && _ctx.saveTask(...args))),
                class: "px-4 py-2 bg-primary-500 text-white rounded",
                disabled: _ctx.saveLoading
              }, [
                (_ctx.saveLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.directT('todoList.saving')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.directT('todoList.save')), 1))
              ], 8, _hoisted_65)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal && _ctx.viewingTask)
      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h2", _hoisted_70, _toDisplayString(_ctx.directT('todoList.details')), 1),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.directT('todoList.id')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.viewingTask.id), 1)
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.directT('todoList.title')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.viewingTask.tasktitle), 1)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.directT('todoList.assignedTo')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.viewingTask.assignedName || _ctx.directT('todoList.notAssigned')), 1)
            ]),
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.directT('todoList.dueDate')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.viewingTask.duedate)), 1)
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.directT('todoList.priority')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.getLocalizedPriority(_ctx.viewingTask.priority || 'medium')), 1)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.directT('todoList.status')) + ":", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.getLocalizedStatus(_ctx.viewingTask.status)), 1)
            ]),
            (_ctx.viewingTask.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.directT('todoList.description')) + ":", 1),
                  _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.viewingTask.description), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                class: "px-4 py-2 bg-gray-200 dark:bg-[#172036] rounded"
              }, _toDisplayString(_ctx.directT('todoList.close')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}